import React from 'react';
import { RowSelectionAction } from '@europrocurement/flexy-datatable';
import {
    useOrderTable as useDefaultDossierTable,
    useDossierFilters,
    useDossierPreFilters,
} from '@europrocurement/l2d-modules';
import ActionMenu from '../views/liste/ActionMenu/ActionMenu';

const useOrderTable = () => {
    const { columns } = useDefaultDossierTable();
    const { frontDossierFilter } = useDossierFilters();
    const { frontPreFilters } = useDossierPreFilters();

    columns.push({
        label: 'Actions',
        displayLabel: false,
        render: (collection) => <ActionMenu collection={collection} />,
        isDisplayed: true,
        sortable: false,
        sx: {
            display: {
                xs: 'none',
                sm: 'none',
                md: 'table-cell',
                lg: 'table-cell',
                xl: 'table-cell',
            },
        },
    });

    const rowActions: RowSelectionAction[] = [];

    return { columns, filters: frontDossierFilter, preFilters: frontPreFilters, rowActions };
};

export default useOrderTable;
